import { useProductDetailState } from 'contexts';
import { useTenantConfig } from 'hooks';
import { t } from 'i18n';
import Head from 'next/head';
import { useRouter } from 'next/router';
import React from 'react';

export const BreadcrumbSchema: React.FC = () => {
  const { breadcrumbs } = useProductDetailState();
  const { baseDomain, addSchemaBreadcrumbList } = useTenantConfig();
  const { asPath } = useRouter();

  return (
    <>
      {!!addSchemaBreadcrumbList && !!breadcrumbs?.length && (
        <Head>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'BreadcrumbList',
                itemListElement: breadcrumbs.map(
                  ({ name, link, isLast }, index) => ({
                    '@type': 'ListItem',
                    position: index + 1,
                    item: {
                      name: !index ? t('Trang chủ') : name, // index = 0, alway show "trang chủ" cause on dev env is showing icon home
                      '@id':
                        link === '#' || !!isLast
                          ? `${baseDomain}${asPath}`
                          : `${baseDomain}${link}`,
                    },
                  }),
                ),
              }),
            }}
          />
        </Head>
      )}
    </>
  );
};
